// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Z4-z","colorTextValue":"_4-z","swatches":"a5-z","collapseLink":"b5-z","isCollapsed":"c5-z","dropdown":"d5-z","disabled":"e5-z"};